import React from 'react';
import { Button, Typography } from '@material-ui/core';

const MainFundSection = ({
  isCoInvestment,
  showMainFundError,
  hasSelectedFund,
  classes,
  onClear,
  onSelect,
  renderSelectedFund
}) => {
  if (hasSelectedFund) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingTop: '2px'
        }}
      >
        {renderSelectedFund(isCoInvestment)}
        <Button
          onClick={onClear}
          style={{
            marginLeft: '8px',
            marginTop: '13px',
            minWidth: '32px'
          }}
          color="secondary"
        >
          X
        </Button>
      </div>
    );
  }

  return (
    <div>
      <Typography
        style={{
          color: showMainFundError ? '#FF0000' : '#757575',
          fontSize: '14px',
          lineHeight: '20px',
          display: 'block',
          marginBottom: '6px'
        }}
      >
        {isCoInvestment ? 'Main Fund *' : 'Main Fund'}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        classes={{
          root: showMainFundError ? classes.errorButton : undefined
        }}
        style={{
          textTransform: 'none',
          borderColor: showMainFundError ? '#FF0000' : undefined,
          fontSize: '0.8125rem',
          justifyContent: 'center',
          height: '32px'
        }}
        onClick={onSelect}
      >
        Select
      </Button>
    </div>
  );
};

export default MainFundSection;
